import React from "react";
import PropTypes from "prop-types";

const InlineError = ({ text }) => <p className="text-danger font-weight-bold mb-0" > {text}</p>;

InlineError.propTypes = {
  text: PropTypes.string.isRequired,
};
export default InlineError;
